<template>
  <div>
    <AdminNav />
    <div class="page">
      <h2 class="page-title">Tableau de bord global</h2>

      <div class="stats-grid" v-if="stats">
        <div class="stat-card">
          <div class="stat-icon">🏪</div>
          <div class="stat-value">{{ stats.nb_commercants }}</div>
          <div class="stat-label">Commerçants actifs</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">👥</div>
          <div class="stat-value">{{ stats.nb_clients }}</div>
          <div class="stat-label">Clients inscrits</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">🧾</div>
          <div class="stat-value">{{ stats.nb_transactions }}</div>
          <div class="stat-label">Transactions</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">💶</div>
          <div class="stat-value">{{ formatEuro(stats.ca_transactions) }}</div>
          <div class="stat-label">CA total fidélisé</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">📅</div>
          <div class="stat-value">{{ stats.nb_journees }}</div>
          <div class="stat-label">Journées clôturées</div>
        </div>
      </div>

      <!-- Classement par commerçant -->
      <div class="card" v-if="stats">
        <h3>Performance par commerçant</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Enseigne</th>
              <th>CA total</th>
              <th>Journées</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in stats.par_commercant" :key="c.nom_enseigne">
              <td><strong>{{ c.nom_enseigne }}</strong></td>
              <td>{{ formatEuro(c.ca_total || 0) }}</td>
              <td>{{ c.nb_journees }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import AdminNav from '../../components/AdminNav.vue'
import adminApi from '../../adminApi'

export default {
  name: 'AdminDashboard',
  components: { AdminNav },
  data() { return { stats: null } },
  methods: {
    formatEuro(v) { return Number(v||0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }) },
    async charger() {
      try { const res = await adminApi.get('/stats'); this.stats = res.data } catch {}
    }
  },
  mounted() { this.charger() }
}
</script>

<style scoped>
.page { padding: 24px; max-width: 1100px; margin: 0 auto; }
.page-title { font-size: 22px; font-weight: 700; margin-bottom: 20px; }
.stats-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 12px; margin-bottom: 20px; }
.stat-card { background: white; border-radius: 14px; padding: 20px; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.stat-icon { font-size: 24px; margin-bottom: 8px; }
.stat-value { font-size: 24px; font-weight: 700; color: #2d3748; }
.stat-label { font-size: 12px; color: #718096; margin-top: 4px; }
.card { background: white; border-radius: 14px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.card h3 { font-size: 16px; font-weight: 700; margin-bottom: 16px; }
.table { width: 100%; border-collapse: collapse; font-size: 14px; }
.table th { text-align: left; padding: 10px 12px; font-size: 12px; color: #718096; border-bottom: 2px solid #e2e8f0; }
.table td { padding: 12px; border-bottom: 1px solid #f0f0f0; }
.table tr:hover td { background: #f7fafc; }
@media (max-width: 900px) { .stats-grid { grid-template-columns: repeat(2, 1fr); } }
</style>
